/* ==========================================================================
 *  Function: Dropdown
 * ======================================================================= */
function componentDropdown() {
  if ($(".js-dropdown-trigger").length) {
    $(".js-dropdown-trigger").on("click", function () {
      if ($(window).width() < 992) {
        $(this).closest(".js-dropdown-block").toggleClass("is-active");
      }
    });
  }
}
